import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageContainerDirective } from './message-container.directive';

@NgModule({
    imports: [ CommonModule ],
    exports: [ MessageContainerDirective ],
    declarations: [ MessageContainerDirective ],
})
export class MessageContainerDirectiveModule {}
